import { BaseElementToSimpleSapElementMapper } from './baseElementToSimpleSapElementMapper';
import Element from '@/models/element';
import { ISimpleSapElement, SimpleSapElement } from '@/models/api/models/simpleSapElement';

export class HandleToSimpleSapElementMapper extends BaseElementToSimpleSapElementMapper {

    public map(element: Element): ISimpleSapElement[] {
        const type = this.toHandleType(element);
        const handle = SimpleSapElement.HANDLE(type, '');
        return [handle];
    }
}
